import { ApiBooking } from '@ibe/api';
import {
  OSSPPlaceholders,
  OSSPPlaceholderToPageConfig
} from '../Config/OSSPPlaceholderToPageConfig';
import dayjs from 'dayjs';

const FLEX_BOX_LINK_PLACEHOLDER = /\{\{.*?}}/g;
const FLEX_BOX_LINK_SEPARATOR = '|';

const LINK_ELEMENT_URL_PLACEHOLDER = 'PAGE_LINK';
const LINK_ELEMENT_START = '<a href="PAGE_LINK">';
const LINK_ELEMENT_END = '</a>';

export abstract class PlaceholderUtils {
  public static map(booking: ApiBooking, originalContent: string, dateFormat: string): string {
    let mappedString = originalContent;
    const linkPlaceholdersInText = originalContent.match(FLEX_BOX_LINK_PLACEHOLDER) || [];

    linkPlaceholdersInText.forEach(linkPlaceholder => {
      mappedString = mappedString.replace(
        linkPlaceholder,
        PlaceholderUtils.getValueForPlaceholder(linkPlaceholder)
      );
    });

    return mappedString
      .replaceAll(OSSPPlaceholders.BOOKING_DATE, dayjs(booking.bookingDate).format(dateFormat))
      .replaceAll(
        OSSPPlaceholders.TRAVEL_START_DATE,
        dayjs(booking.travelStartDate).format(dateFormat)
      )
      .replaceAll(
        OSSPPlaceholders.TRAVEL_END_DATE,
        dayjs(booking.travelEndDate).format(dateFormat)
      );
  }

  private static getValueForPlaceholder(placeholderNode: string): string {
    const extractedPlaceholderData: string[] = placeholderNode
      .replaceAll('{', '')
      .replaceAll('}', '')
      .split(FLEX_BOX_LINK_SEPARATOR);

    // condition for correctly defined link placeholder -> it needs to contain both page information and button label
    if (extractedPlaceholderData.length == 2) {
      const relatedPageUrl = OSSPPlaceholderToPageConfig.get(extractedPlaceholderData[0]);

      const linkLabel = extractedPlaceholderData[1] || '';

      if (relatedPageUrl && linkLabel) {
        return `${LINK_ELEMENT_START}${linkLabel}${LINK_ELEMENT_END}`.replace(
          LINK_ELEMENT_URL_PLACEHOLDER,
          relatedPageUrl
        );
      }
    }
    return '';
  }
}
